import { useState, useEffect } from 'react';

// eslint-disable-next-line no-unused-vars
import { Amplify, PubSub, Hub } from 'aws-amplify';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AWSIoTProvider, CONNECTION_STATE_CHANGE } from '@aws-amplify/pubsub';

const awsSettings = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:3d64a180-c3cb-4667-8ef7-bc4e638bc8ce',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_wnqqcukln',
  aws_user_pools_web_client_id: '1koospu8p8kklluvat17i0ala2',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

export default function useIot() {
  const [connectionState, setConnectionState] = useState(null);

  useEffect(() => {
    Hub.listen('pubsub', (data) => {
      const { payload } = data;

      if (payload.event === CONNECTION_STATE_CHANGE) {
        const { connectionState: status } = payload.data;
        setConnectionState(status);
      }
    });

    Amplify.addPluggable(new AWSIoTProvider({
      aws_pubsub_region: 'us-east-2',
      aws_pubsub_endpoint: 'wss://a2prcbd4el2hlx-ats.iot.us-east-2.amazonaws.com/mqtt',
    }));
    Amplify.configure(awsSettings);
  }, []);

  return { connectionState };
}
